import React from 'react';
import { WizardItemType } from '../../Enums/WizardItemType.enum';
import { WizardItemSubtype } from '../../Enums/WizardItemSubtype.enum';
import WizardVStack from './WizardVStack/WizardVStack';
import WizardScreen from './WizardScreen/WizardScreen';
import WizardAppNewsButton from './WizardAppNewsButton/WizardAppNewsButton';
import WizardButton from './WizardButton/WizardButton';
import WizardCarousel from './WizardCarousel/WizardCarousel';
import WizardText from './WizardText/WizardText';
import WizardVideo from './WizardVideo/WizardVideo';
import WizardImage from './WizardImage/WizardImage';
import WizardSubmitButton from './WizardSubmitButton/WizardSubmitButton';
import WizardContainer from './WizardContainer/WizardContainer';
import { WizardType } from '../../Enums/WizardType.enum';
import WizardTip from './WizardTip/WizardTip';
import WizardWrapper from './WizardWrapper/WizardWrapper';

interface WizardItemSettings {
	gap?: string;
	title?: string;
	icon?: string;
	action?: {
		type: string;
		url?: string;
		destination?: string;
		wizardId?: string;
		wizardKey?: string;
	};
	carousel?: string;
	slide?: number;
	thumbnailUrl?: string;
	url?: string;
	style?: React.CSSProperties;
	fullscreen?: boolean;
	banner?: {
		imageUrl: string;
	};
	badge?: {
		text: string;
	};
	showLogo: boolean;
}

export interface IWizardItem {
	key?: string;
	type: WizardItemType;
	subtype?: WizardItemSubtype;
	settings?: WizardItemSettings;
	children?: IWizardItem[];
	rank?: number;
	title?: string;
	description?: string;
	data?: {
		nextStep: string;
		nextStepData: object;
	};
}

interface Props {
	item: IWizardItem;
	isCarouselChild?: boolean;
	type?: WizardType;
}

const WizardItem: React.FC<Props> = ({
	item,
	isCarouselChild = false,
	type,
}) => {
	if (item.key === 'redirect') {
		switch (item.settings?.action?.destination) {
			case 'homepage':
				// @ts-ignore
				window.location.href = '/';
				break;
		}
	}

	switch (item.type) {
		case WizardItemType.DYNAMIC:
			switch (type) {
				case WizardType.PAYMENT_METHOD:
					return <WizardWrapper item={item} />;
				case WizardType.TIP:
					return <WizardTip item={item} />;
				default:
				case WizardType.DEFAULT:
					return <WizardScreen item={item} isCarouselChild={isCarouselChild} />;
			}
		case WizardItemType.V_STACK:
			return <WizardVStack item={item} />;
		case WizardItemType.APP_NEWS_BUTTON:
			return <WizardAppNewsButton item={item} />;
		case WizardItemType.BUTTON:
			return <WizardButton item={item} />;
		case WizardItemType.CAROUSEL:
			return <WizardCarousel item={item} />;
		case WizardItemType.TEXT:
			return <WizardText item={item} />;
		case WizardItemType.VIDEO:
			return <WizardVideo item={item} />;
		case WizardItemType.IMAGE:
			return <WizardImage item={item} />;
		case WizardItemType.SUBMIT_BUTTON:
			return <WizardSubmitButton item={item} />;
		case WizardItemType.CONTAINER:
			return <WizardContainer item={item} />;
		default:
			return <>Unsupported item: {item.type}</>;
	}
};

export default WizardItem;
